// extracted by mini-css-extract-plugin
export default {"control":"Navigation_control__DHRtu","link":"Navigation_link__2w9W2","chevron":"Navigation_chevron__SmU++"};